
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const [{createUI, installThemeToggle, installHashImportBanner}, {createGameUI, loadGame, makeClient, prepareGameFile}] = await Promise.all([import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  return module;
}), import("./lib/bgio.js").then((module) => {
  if (!("createGameUI" in module)) throw new SyntaxError(`export 'createGameUI' not found`);
  if (!("loadGame" in module)) throw new SyntaxError(`export 'loadGame' not found`);
  if (!("makeClient" in module)) throw new SyntaxError(`export 'makeClient' not found`);
  if (!("prepareGameFile" in module)) throw new SyntaxError(`export 'prepareGameFile' not found`);
  return module;
})]);
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint } = createUI({ html });
const { gameBoard, mountEditor, mountGameSection } = createGameUI({ html });
const starter = prepareGameFile(2);
return {createUI,installThemeToggle,installHashImportBanner,createGameUI,loadGame,makeClient,prepareGameFile,codeEditor,ok,err,hint,gameBoard,mountEditor,mountGameSection,starter};
},
    inputs: ["html","display"],
    outputs: ["createUI","installThemeToggle","installHashImportBanner","createGameUI","loadGame","makeClient","prepareGameFile","codeEditor","ok","err","hint","gameBoard","mountEditor","mountGameSection","starter"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-3`),
    expanded: [],
    variables: []
  },
  {
    id: 3,
    body: (codeEditor,starter,html,loadGame,makeClient,err,ok,gameBoard,mountEditor,mountGameSection) => {
const editor = codeEditor("bgio:game", { value: starter, label: "Deine Datei: TicTacToe.js" });
const boardSlot = html`<div></div>`;
const feedbackSlot = html`<div></div>`;

function check(code) {
  try {
    const game = loadGame(code);

    const c1 = makeClient(game);
    if (!(c1.getState() && c1.getState().G && Array.isArray(c1.getState().G.cells)))
      throw new Error("setup gibt noch kein { cells: [...] } zurück (siehe Kapitel 1).");
    c1.moves.clickCell(0);
    const owner = c1.getState().G.cells[0];
    c1.moves.clickCell(0);
    const rejectsOccupied = c1.getState().G.cells[0] === owner && owner !== null;

    const c2 = makeClient(game);
    const p0 = c2.getState().ctx.currentPlayer;
    c2.moves.clickCell(4);
    const switched = c2.getState().ctx.currentPlayer !== p0;

    if (!rejectsOccupied)
      return err(html`Ein Klick auf ein belegtes Feld sollte abgelehnt werden — gib <code>INVALID_MOVE</code> zurück, wenn <code>move.G.cells[cellIndex] !== null</code>.`);
    if (!switched)
      return err(html`Nach einem Zug sollte automatisch der nächste Spieler dran sein — füg <code>turn: { minMoves: 1, maxMoves: 1 }</code> hinzu.`);
    return ok(html`🎉 Ungültige Züge werden abgelehnt und der Spieler wechselt automatisch.`);
  } catch (e) {
    return err(html`Dein Code lässt sich nicht ausführen: ${e.message}`);
  }
}

function rerun() {
  const code = editor.value;
  boardSlot.replaceChildren(gameBoard(code, {
    showDebug: true,
    showState: true,
    hint: "Versuch zweimal aufs selbe Feld zu klicken — der zweite Klick wird abgelehnt. Und nach jedem gültigen Klick wechselt der Spieler (✕ ↔ ◯)."
  }));
  feedbackSlot.replaceChildren(check(code));
}
mountEditor({ editor });
const section = mountGameSection({
  nodes: [boardSlot, feedbackSlot],
  onRun: () => { const b = editor.querySelector(".run-button"); if (b) b.click(); }
});
editor.addEventListener("input", () => { rerun(); section.expand(); });
rerun();
return {editor,boardSlot,feedbackSlot,check,rerun,section};
},
    inputs: ["codeEditor","starter","html","loadGame","makeClient","err","ok","gameBoard","mountEditor","mountGameSection"],
    outputs: ["editor","boardSlot","feedbackSlot","check","rerun","section"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
